<template>
  <div class="content blacklist">
    <div class="header">
      <div class="box">
        <el-input
          placeholder="请输入内容"
          prefix-icon="el-icon-search"
          v-model="input2">
        </el-input>
        <el-button type="primary">搜索</el-button>
      </div>
      
    </div>
    <template>
      <el-table :data="tableData" style="width: 100%" size="small">
        <el-table-column prop="sort" label="排序" width="140"></el-table-column>
        <el-table-column prop="title" label="会员名称" ></el-table-column>
        <el-table-column prop="title" label="加油时间" ></el-table-column>
        <el-table-column prop="title" label="金额" ></el-table-column>
        <el-table-column prop="title" label="油品" ></el-table-column>
        <el-table-column prop="title" label="油枪" ></el-table-column>
        <el-table-column prop="title" label="礼品/数量" ></el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="text" @click="deleteRow(scope.$index, scope)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      page_id: "",
      tableData: []
    };
  },
  mounted() {
    this.page_id = this.$route.params.id;
    this.getLocalData();
  },
  methods: {
    // 获取数据
    getLocalData() {
    },
    // 删除行
    deleteRow(index, row) {
      console.log(index, row);
    //   this.tableData.splice(index, 1)
    //   localStorage.setItem("sliceList", JSON.stringify(this.tableData));
    },
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 0 55px 30px 0;
  height: calc(100vh - 102px);
  border: 1px solid #f1f1f1;
  overflow: auto;
  min-width: 900px;
}
.blacklist {
  padding: 10px 25px;
  .header {
    padding: 10px 10px;
    display: flex;
    justify-content: flex-end;
    .box{
      width: 260px;
      display: flex;
    }
  }
  .img {
    width: 100%;
    height: 100px;
    text-align: center;
    line-height: 100px;
    img {
      width: 80%;
    }
  }
}
</style>